<template>
  <div>
    <div class="top">
      <div class="top_main clearfix">
        <div class="top_logo" @click="gomain"></div>
        <ul class="top_menu">
          <li
            v-for="(v, i) in menuList"
            :key="i"
            :class="{ active: menuText == v.id }"
            @click="scrollTo(v.code, v.id)"
          >
            <a class="scrollA" href="#">{{ v.name }}</a>
            <i></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="main" id="main">
      <div class="main_top clearfix">
        <div class="main_top_">
          <div class="main_top_1">
            <div class="main_top_1_1"></div>
          </div>
          <div class="main_top_2">
            <div class="main_top_2_1"></div>
            <!-- <img src="../../static/images/main_top_2_1.png" alt=""  width="354px;" height="auto" srcset=""> -->
            <img
              src="../../static/images/webpc.gif"
              alt=""
              width="354px;"
              height="225px"
              srcset=""
            />
            <img
              src="../../static/images/topbottom.png"
              alt=""
              width="802px;"
              height="169px"
              srcset=""
              style="margin-top:25px;margin-left:-107px;"
            />
            <div class="main_top_2_2"></div>
            <div class="main_top_2_3">
              将数字技术与业务深度融合，服务校园生活、提高办公效率、优化管理理念、支撑智慧决策，让智慧校园更智慧
            </div>
          </div>
          <div class="main_top_3">
            <div class="main_top_3_1"></div>
          </div>
        </div>
      </div>
      <div class="main_middle" id="zhhq">
        <div class="middle_text">
          <h3>智慧后勤建设</h3>
          <p>
            高校智慧后勤是管理与服务的载体，是利用信息化来提高后勤服务质量、提高精细化管理水平、提升安全管理机制，是后勤服务方式和管理模式的优化改革。
          </p>
        </div>
        <div class="middle_menu">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            @select="handleOpen"
            text-color="rgba(51, 51, 51, 1)"
            active-text-color="#fff"
          >
            <!-- class="animate__animated animate__bounceInDown" -->
            <el-menu-item
              v-for="item in midMenus"
              :index="item.id"
              :key="item.id"
            >
              <img
                class="menuIcon"
                :src="require(`../../static/images/m${item.icon}.png`)"
                alt=""
                v-if="defaultActive == item.id"
              />
              <img
                class="menuIcon"
                v-else
                :src="require(`../../static/images/${item.icon}.png`)"
                alt=""
              />
              <span class="menuTitle">{{ item.text }}</span>
            </el-menu-item>
          </el-menu>
          <transition :name="animation">
            <el-carousel
              class="carous"
              id="carous"
              :interval="4000"
              height="402px"
              :autoplay="true"
              :arrow="cItems.length <= 1 ? 'never' : 'hover'"
              indicator-position="outside"
            >
              <!-- :indicator-position="cItems.length <= 1 ? 'none' : 'outside'" -->
              <el-carousel-item v-for="item in cItems" :key="item.head">
                <div class="cHead" :key="item.head + 23">{{ item.head }}</div>
                <div v-for="line in item.lines" :key="line" class="carousLine">
                  <img :src="require('../../static/images/bluecheck.png')" />{{
                    line
                  }}
                </div>
              </el-carousel-item>
            </el-carousel>
          </transition>
        </div>
      </div>
      <!-- 2智慧图书馆 -->
      <div class="main_black" id="zhtsg">
        <span class="logo1"></span>
        <span class="logo2"></span>
        <div class="mainBlack_">
          <h3>智慧图书馆建设</h3>
          <p>
            图书馆是学生在学校生活的重要场所，也是智能管理需求较为集中的场所，南京昂克软件基于图书馆场景开发了多个实用性极强的软件产品，为读者提供更便捷、高效的服务，实现图书馆服务工作的智能化及高效化。
          </p>
          <div class="mainBlack_tab">
            <ul>
              <li
                :class="[{ active: i == blackTabsNum }, 'li' + v.id]"
                v-for="(v, i) in blackTabs"
                :key="i"
                @click="changeTab(v.id)"
              >
                {{ v.name }}
              </li>
            </ul>
            <!-- 昂克HiSeat选好座 -->
            <div
              class="box"
              :class="[
                { radius1: blackTabsNum == 0 },
                { radius5: blackTabsNum == 6 }
              ]"
            >
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 0" @click="gogodetail_zh(0)">
                  <h3>ESI数据开放服务系统</h3>
                  <p>
                    实现高校ESI学科数据的导入、处理、规范、集成与分析，建立适用于ESI院系级服务的数据标准规范，实现基于时间序列的ESI学科数据状态管理和本地化存储，全力保障“学术影响力提升计划”的推进实施，学科建设提供全方位的数据支撑服务
                  </p>
                  <div class="mainBlackTab_img"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 1" @click="gogodetail_zh(1)">
                  <h3>昂克HiSeat选好座</h3>
                  <p>
                    在传统占座系统功能上升级优化，实现了在线选座、提前预约、多种方式签到、中途占离、违规举报、榜单排名、后台管理与分析于一体的智能座位预约。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img1"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 2" @click="gogodetail_zh(2)">
                  <h3>空间管理</h3>
                  <p>
                    集学校空间资源管理、学生智能预约系统、智能签到、学校统计监督优化功能于一体，帮助学校借助信息化手段和先进的管理理念对教室的使用率进行规范化和实时化管理。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img2"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 3" @click="gogodetail_zh(3)">
                  <h3>古籍数字化</h3>
                  <p>
                    多种古籍字典，如纪年库、古代政府机构。支持资源查找及检索、资源分类、资源可视化阅读及常用工具。支持个性化加工规则，操作性强。双重检测匹配，增量再加工。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img3"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 4" @click="gogodetail_zh(4)">
                  <h3>读者教育</h3>
                  <p>
                    国内首家专业读者教育软件，创造教育和移劢互联网结合新局面。简化图书馆教育环节，提高教育效率。增加图书馆推广渠道，利用移劢
                    APP 与微信端进行对外宣传与推广。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img4"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 5" @click="gogodetail_zh(5)">
                  <h3>图书漂流</h3>
                  <p>
                    书籍共享、渠道互通、读者相交。<br />
                    读者把书放入平台书架，将其漂出手，让下一位爱书人阅读，继续一段漂流书香。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img5"></div>
                </div>
              </transition>
              <transition class="container" :name="transitionName">
                <div v-if="blackTabsNum == 6" @click="gogodetail_zh(6)">
                  <h3>全景导览</h3>
                  <p>
                    全景式读者教育：浏览式学习、场景式考试；全景式座位预约、全景式空间预约。
                  </p>
                  <div class="mainBlackTab_img mainBlackTab_img6"></div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- 3其他业务领域 -->
      <div class="other" id="other">
        <span class="back1"></span>
        <span class="back2"></span>
        <h3>其他业务领域</h3>
        <p>涵盖多个业务领域，功能应用全面高效</p>
        <ul>
          <li
            v-for="(item, index) in otherLists"
            :key="index"
            @click="gogodetail_qt(item.id)"
          >
            <h3>
              <span :class="'backimg' + item.id"></span> {{ item.title }}
              <i class="line"></i>
              <i class="new" v-if="index == 0">new</i>
            </h3>
            <p>{{ item.text }}</p>
          </li>
        </ul>
      </div>
      <!-- 4我们的客户 -->
      <div class="customer" id="customer">
        <h3>我们的客户</h3>
        <p>信赖合作，长远发展</p>
        <ul>
          <li @click="changeCustomer(0)" :class="{ active: customerNum == 0 }">
            <i class="el-icon-arrow-left"></i> 高校用户
          </li>
          <li @click="changeCustomer(1)" :class="{ active: customerNum == 1 }">
            企业单位
            <i class="el-icon-arrow-right"></i>
          </li>
        </ul>
        <transition class="container" name="slide-fade">
          <div v-if="customerNum == 0" class="customerlists"></div>
        </transition>
        <transition class="container" name="slide-fade1">
          <div v-if="customerNum == 1" class="companylists"></div>
        </transition>
      </div>
      <!-- 5关于我们 -->
      <div class="about" id="about">
        <h3>关于我们</h3>
        <div class="aboutText">
          <p>
            南京昂克软件有限公司，成立于2005年，坐落于南京市建邺区新城科技园内，致力于做高校信息化建设。
          </p>
          <p>
            十几年来，南京昂克软件有限公司一直深耕高校智慧校园的场景建设，尤其是高校图书馆和智慧后勤应用软件的研发，具备众多知识产权与专利认证，
            多年来，凭借强大的研发能力和完善的技术服务体系，与全国各地高校在软件产品和系统开发方面均有很好的合作。
          </p>
          <p>
            为客户提供专业的应用软件服务是我们一贯的追求，未来昂克软件将继续深耕高校信息化市场，努力为客户提供更多的产品和更高效稳定的服务，让每一位使用软件的人都能够用的放心。
          </p>
          <ul class="aboutDetail clearfix">
            <li>
              <p>
                <i class="location"></i>地址：南京市建邺区创智路2号瑞泰大厦801
              </p>
              <p><i class="tel"></i>电话：025-52333182</p>
              <p><i class="email"></i>邮箱：dev@angke.com.cn</p>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "南京昂克软件有限公司", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content: "南京昂克软件有限公司,智慧后勤,智慧图书馆,读者教育,网上报修"
      },
      {
        name: "description",
        content: "南京昂克软件有限公司,智慧后勤,智慧图书馆,读者教育,网上报修"
      }
    ]
  },
  data() {
    return {
      animation: "slide-carous",
      menuList: [
        {
          name: "首页",
          code: "main",
          id: 0
        },
        {
          name: "智慧后勤",
          code: "zhhq",
          id: 1
        },
        {
          name: "智慧图书馆",
          code: "zhtsg",
          id: 2
        },
        {
          name: "其他业务领域",
          code: "other",
          id: 3
        },
        {
          name: "客户",
          code: "customer",
          id: 4
        },
        {
          name: "关于",
          code: "about",
          id: 5
        }
      ],
      menuText: 0,
      menuName: "main",
      middleLists: [
        {
          name: "网上报修平台",
          text:
            "覆盖全校区域的全面报修，智能分配各维修单位，电话报修的快速录单，实现了全校各类故障的快速及便捷的报修；实现报修单的责任到人；实现报修、维修、确认的闭环流程。",
          id: 0
        },
        {
          name: "线上订餐系统",
          text:
            "线上订餐系统，为高校师生提供食堂菜品的线上订餐及配送服务，实现单位订餐的内部转账单结算以及个人订餐的校园卡支付，提高饮食中心的服务效率和服务质量。",
          id: 1
        },
        {
          name: "物业服务监管平台",
          text:
            "物业服务监管平台以检查任务为核心，实现物业服务的检查任务下发、执行检查、问题整改反馈及确认的业务流程闭环，为物业服务质量的监管提供依据。",
          id: 2
        },
        {
          name: "绩效奖励分配系统",
          text:
            "绩效奖励分配系统解决后勤人员各类绩效奖励的录入、考核小组确认及领导审核……",
          id: 3
        },
        {
          name: "后勤门户网站",
          text:
            "系统化的后勤门户网站在于对后勤要呈现的内容准确的分类，如首页展示时效性强……",
          id: 4
        },
        {
          name: "后勤主题数据库",
          text: "底层基础数据架构，后勤人财物的全面管理，业务数据支撑和回流。",
          id: 5
        },
        {
          name: "后勤服务中心",
          text:
            "后勤服务中心聚合后勤相关的所有应用，为全校师生提供后勤服务的统一平台，便……",
          id: 6
        },
        {
          name: "监督管理平台",
          text:
            "服务反馈评价体系，为全校师生提供后勤各业务领域的监督入口。提高后勤服务满……",
          id: 7
        },
        {
          name: "高校宿舍管理系统",
          text:
            "支持多平台，在线进行学生宿舍分配工作，紧扣各环节，避免传统模式因工作繁忙……",
          id: 8
        }
      ],
      blackTabs: [
        {
          name: "ESI",
          id: 0
        },
        {
          name: "选好座",
          id: 1
        },
        {
          name: "空间管理",
          id: 2
        },
        {
          name: "古籍数字化",
          id: 3
        },
        {
          name: "读者教育",
          id: 4
        },
        {
          name: "图书漂流",
          id: 5
        },
        {
          name: "全景导览",
          id: 6
        }
      ],
      blackTabsNum: 0,
      transitionName: "slide-right",
      otherLists: [
        {
          title: "资源预约平台",
          text:
            "支持学校各类资源的在线预约，如座位、自习室、研讨间等，实现先预约再使用，提高各类资源的利用率。统计分析，体现业绩增长及管理水平。",
          id: 0
        },
        {
          title: "统战管理系统",
          text:
            "系统覆盖所有统战对象，实现人人参与。利用信息化手段收集和统计信息，团结协作，共同奋战。与统一平台对接，告别信息孤岛，实现信息共享。贯彻统战工作方针，体现统战工作成果。",
          id: 1
        },
        {
          title: "高校基金会管理系统",
          text:
            "多平台整合，拓宽基金会宣传渠道，增加互动，提升社会关系。提供资金捐赠网页在线支付和手机扫码支付通道，支持微信支付和支付宝支付，捐赠更加便捷。提升校友们的荣誉感、责任感以及归属感。",
          id: 2
        },
        {
          title: "运维服务系统",
          text:
            "昂克运维服务系统，不仅仅是一个软件，更是一个标准化服务的管理理念。它实现了资产管理监控和维修流程标准化、透明化的管理。支持本地部署和云平台，简单易用，提供移动端App。",
          id: 3
        },
        {
          title: "项目建设管理平台",
          text:
            "平台可实现高校项目建设的申请、立项、采购、合同、验收等建设流程的全过程管理，可实现项目的多层级审批管理、项目进度可视化呈现。",
          id: 4
        },
        {
          title: "昂克微信基础服务平台",
          text:
            "平台为高校、企业提供公众号服务，将公众号服务器地址和Token接入平台，利用平台可以很快的定制一个公众号管理平台，也可以通过模板5分种内打造一个超炫H5网站。",
          id: 5
        },
        {
          title: "好动体育管理云平台",
          text:
            "针对高校体育事业开发，专注体育和体质健康信息化。以促进国民体质健康为己任，坚持以数据服务于学校体育教学与管理、激发学生的体育锻炼热情，进而推动全民健身运动，提高国民体质健康水平。",
          id: 6
        },
        {
          title: "绩效考核系统",
          text: "科研绩效考核。",
          id: 7
        }
      ],
      customerNum: 0,
      flag: true,
      defaultActive: "0",
      midMenus: [
        {
          id: "0",
          text: "综合管理",
          icon: "zonghe",
          items: [
            {
              head: "线上业务研讨协作系统",
              lines: [
                "横向打通后勤各业务，集中展示板块数据",
                "智能监控分析各业务管理日常，及时发现并预警",
                "智能监控分析各业务管理日常，及时发现并预警",
                "收集整理各类业务资料，信息同步高效协作"
              ]
            },
            {
              head: "内部审批系统",
              lines: [
                "预设多类审批模板，更懂后勤各项事务场景的工作流",
                "可自定义申请模板，自助提交申请，负责人多端审批",
                "随时查看进度，自动跟进提醒，信息透明、流程高效"
              ]
            },
            {
              head: "后勤人事管理系统",
              lines: [
                "组织架构清晰可见，人员信息维度丰富",
                "入职、调动/借调、离职、退休、岗位聘任全生命周期管理",
                "多种考勤方案，支持考核自评、互评、审批等全流程在线考核",
                "对接招聘平台，自动采集人员信息，智能入职"
              ]
            },
            {
              head: "信息化项目管理系统",
              lines: [
                "服务于校园信息化项目的管理过程，多类项目申报采购、多级审批过程",
                "信息化项目申报、立项、采购、合同、验收的整体过程管理",
                "支持软件类项目的接入申请和验收过程管理"
              ]
            }
          ]
        },
        {
          id: "1",
          text: "监管服务",
          icon: "jianguan",
          items: [
            {
              head: "综合服务监督系统",
              lines: [
                "统一汇聚咨询、反馈、投诉、表扬、其他等多类型问题，进行专业化回复",
                "智能分析积累的业务数据，助力查找问题、改进工作、提升服务水平",
                "建立监管机制，根据目标计划分解任务，提供方便快捷的检查工具",
                "关注问题的发现和处理的结果，促进问题的及时响应和快速整改"
              ]
            },
            {
              head: "绩效奖励发放系统",
              lines: [
                "高度贴合实际场景，覆盖多类绩效奖励因素",
                "解决人员信息管理、各类绩效奖励的录入和考核确认，规范发放过程",
                "历史绩效和发放依据等数据信息互通无阻塞",
                "支持多端操作，绩效核算更加高效"
              ]
            }
          ]
        },
        {
          id: "2",
          text: "膳食服务",
          icon: "shanshi",
          items: [
            {
              head: "餐饮服务系统",
              lines: [
                "窗口、菜品展示齐全，轻松管理",
                "微信、手机应用、服务中心等多入口点单，灵活选择",
                "灵活取餐时间和堂食、自取、配送等多种就餐模式，效率体验双提升",
                "一卡通、AI人脸识别支付、手机线上支付、单位经费本转账结算等多种支付渠道"
              ]
            }
          ]
        },
        {
          id: "3",
          text: "物业服务",
          icon: "wy",
          items: [
            {
              head: "物业综合管理系统",
              lines: [
                "助力解决服务企业和一线员工人员信息复杂，难以维护管理和考核统计问题",
                "建立物业服务各项工作的作业内容及作业标准，把控一线作业情况",
                "以检查任务为核心，监督检查各服务企业的工作成果",
                "检查任务下发、执行检查、问题整改反馈及确认的业务流程闭环"
              ]
            }
          ]
        },
        {
          id: "4",
          text: "公共服务",
          icon: "gg",
          items: [
            {
              head: "综合报修系统",
              lines: [
                "网上报修、电话报修录单、物业常规巡检报修录单等多种报修方式",
                "根据学校管理方案，自由定制后勤、网络、消防等多种报修类型",
                "网络故障报修智能引导，帮助师生自助解决网络问题",
                "报修单责任到人，根据不同故障情况派单处理。进展可查、闭环管理"
              ]
            },
            {
              head: "车辆管理与服务系统",
              lines: [
                "建立校内校外公共车辆和驾驶员档案，全面掌握车辆状况",
                "定期组织安全培训，提高驾驶员驾驶技能和安全意识，降低驾驶事故风险",
                "用车快捷申请，智能化管理和调度用车，实时提醒",
                "一车一账，费用查看一目了然，支持校内转账和发票结算等多种结算方式",
                "轻松管理排班班车线路，支持车载智能终端硬件，实时查看车辆位置、到站时间"
              ]
            }
          ]
        },
        {
          id: "5",
          text: "基础平台",
          icon: "jichu",
          items: [
            {
              head: "后勤门户网站",
              lines: [
                "整合信息发布渠道，展示后勤信息和业务引导",
                "实时集成后勤核心业务数据，动态展示",
                "集中展示和管理后勤信息和服务，提高管理效率及后勤服务形象"
              ]
            },
            {
              head: "后勤服务中心",
              lines: [
                "聚合后勤服务相关的所有应用，便于师生查找PC端/移动端服务",
                "集成各业务待办信息，实现办理后勤业务的入口统一化",
                "可视化展示服务应用的统计数据，为后勤智慧管理提供有力帮助"
              ]
            },
            {
              head: "后勤服务地图",
              lines: [
                "可视清晰的地图形式，为师生提供信息查询与事项办理服务",
                "师生可在地图上进行建筑、设施、服务的查询，并提供导航",
                "后勤服务更加精准化、个性化与智能化"
              ]
            },
            {
              head: "后勤主题数据库",
              lines: [
                // "横向打通后勤各业务，集中展示板块数据",
                // "智能监控分析各业务管理日常，及时发现并预警",
                // "打通线上线下会议，轻松实现跨区集合开会",
                // "收集整理各类业务资料，信息同步高效协作"
                "后勤人财物的全面管理，搭建一体化主题数据库",
                "标准化底层基础数据架构，开放对接各业务平台，提供数据支撑和回流",
                "综合数据看板，深度整合人员、财务、资产、业务系统等各模块数据"
              ]
            },
            {
              head: "支付结算中心",
              lines: [
                "接入校内转账能力及聚合支付能力，建立后勤业务结算支付标准",
                "面向后勤各类业务及商户开放统一结算及支付能力，包含校园卡支付及校内转账",
                "汇聚多种支付方式，管理对接第三方支付渠道，形成统一聚合的支付通道",
                "支撑商户经营，覆盖各业务的结算及支付模块，助力完成体验升级及效率升级",
                "业务结算管理，为各业务模块提供分层分级的财务结算服务"
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    carous() {
      let obj = this.midMenus.find(m => m.id == this.defaultActive) || {};
      return obj;
    },
    cItems() {
      return this.carous.items || [];
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      //   console.log(key, keyPath);
      this.defaultActive = key;
    },
    scrollTo(name, index) {
      this.menuText = index;
      var h = $("#" + name).offset().top;
      //   console.log("this.flag", this.flag);
      if (this.flag) {
        $("html,body").animate(
          {
            scrollTop: h + "px"
          },
          {
            duration: 600,
            easing: "swing"
          }
        );
      } else {
        $("html,body").animate(
          {
            scrollTop: h + "px"
          },
          {
            duration: 0,
            easing: "swing"
          }
        );
        this.flag = true;
      }
      return false;
    },
    gomain() {
      this.scrollTo("main", 0);
    },
    handleScroll() {
      if (this.$route.path != "/home") {
        return false;
      }
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var arr = [
        {
          name: "main",
          id: 0,
          num: $("#main").offset().top
        },
        {
          name: "zhhq",
          id: 1,
          num: $("#zhhq").offset().top
        },
        {
          name: "zhtsg",
          id: 2,
          num: $("#zhtsg").offset().top
        },
        {
          name: "other",
          id: 3,
          num: $("#other").offset().top
        },
        {
          name: "customer",
          id: 4,
          num: $("#customer").offset().top
        },
        {
          name: "about",
          id: 5,
          num: $("#about").offset().top
        }
      ];
      arr.forEach(e => {
        if (scrollTop + 150 >= e.num) {
          this.menuText = 0;
          this.menuText = e.id;
          this.menuName = e.name;
        }
      });
      if (scrollTop + 700 > arr[5].num) {
        this.menuText = 5;
        this.menuName = arr[5].name;
      }
      window.sessionStorage.setItem("scrollNum", this.menuText);
      window.sessionStorage.setItem("scrollName", this.menuName);
    },
    changeTab(num) {
      if (this.blackTabsNum < num) {
        this.transitionName = "slide-right";
      } else {
        this.transitionName = "slide-left";
      }
      this.blackTabsNum = num;
    },
    changeCustomer(num) {
      this.customerNum = num;
    },
    godetail(id) {
      let routeUrl;
      if (id == 0) {
        routeUrl = this.$router.resolve({
          path: "/wsbx"
        });
      } else if (id == 1) {
        routeUrl = this.$router.resolve({
          path: "/xsdc"
        });
      } else if (id == 2) {
        routeUrl = this.$router.resolve({
          path: "/wyfw"
        });
      } else if (id == 3) {
        routeUrl = this.$router.resolve({
          path: "/jxjl"
        });
      } else if (id == 4) {
        routeUrl = this.$router.resolve({
          path: "/hqmh"
        });
      } else if (id == 5) {
        routeUrl = this.$router.resolve({
          path: "/hqztsjk"
        });
      } else if (id == 6) {
        routeUrl = this.$router.resolve({
          path: "/hqfwzx"
        });
      } else if (id == 7) {
        routeUrl = this.$router.resolve({
          path: "/jdglpt"
        });
      } else if (id == 8) {
        routeUrl = this.$router.resolve({
          path: "/gxssglxt"
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    gogodetail_zh(id) {
      let routeUrl;
      if (id == 0) {
        routeUrl = this.$router.resolve({
          path: "/ESI"
        });
      } else if (id == 1) {
        routeUrl = this.$router.resolve({
          path: "/zwyy"
        });
      } else if (id == 2) {
        routeUrl = this.$router.resolve({
          path: "/kjglxt"
        });
      } else if (id == 3) {
        routeUrl = this.$router.resolve({
          path: "/gjszhpt"
        });
      } else if (id == 4) {
        routeUrl = this.$router.resolve({
          path: "/dzjy"
        });
      } else if (id == 5) {
        routeUrl = this.$router.resolve({
          path: "/ydtg"
        });
      } else if (id == 6) {
        routeUrl = this.$router.resolve({
          path: "/qjdl"
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    gogodetail_qt(id) {
      let routeUrl;
      if (id == 0) {
        routeUrl = this.$router.resolve({
          path: "/zyyypt"
        });
      } else if (id == 1) {
        routeUrl = this.$router.resolve({
          path: "/tzglxt"
        });
      } else if (id == 2) {
        routeUrl = this.$router.resolve({
          path: "/gxjjhglxt"
        });
      } else if (id == 3) {
        routeUrl = this.$router.resolve({
          path: "/ywfwxt"
        });
      } else if (id == 4 || id == 5 || id == 7) {
        return false;
      } else if (id == 6) {
        routeUrl = this.$router.resolve({
          path: "/hdty"
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    enterA(e) {
      // $(e.target).css({
      //     'transform': 'translate(0px, -5px)',
      //     'transition': 'all .5s'
      // })
    },
    leaveA(e) {
      //  $(e.target).css({
      //     'transform': 'translate(0px, 0px)',
      //     'transition': 'all .5s'
      // })
    }
  },
  mounted() {
    // console.log('tag', window.localStorage.getItem('blackTabsNum'))
    if (window.localStorage.getItem("blackTabsNum")) {
      this.blackTabsNum = window.localStorage.getItem("blackTabsNum");
      this.transitionName = "";
      $(".box>div").css({
        transition: "all 0s"
      });
    }
    if (window.sessionStorage.getItem("scrollNum")) {
      this.flag = false;
      this.menuText = window.sessionStorage.getItem("scrollNum");
      this.menuName = window.sessionStorage.getItem("scrollName");
      this.scrollTo(this.menuName, this.menuText);
    }
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
.middle_menu {
  display: flex;
  justify-content: center;
  gap: 22px;
  width: 100%;
  //   height: 402px;
  background: #ffffff;
  padding: 40px 0;
  box-sizing: border-box;
  .menuIcon {
    width: 20px;
    height: 20px;
    margin: 0 16px 0 24px;
  }
  .menuTitle {
    font-size: 16px;
    font-weight: normal;
  }
  /deep/ .el-menu {
    width: 180px;
    border: none;
    .el-menu-item {
      margin-top: 12px;
      width: 180px;
      height: 38px;
      display: flex;
      align-items: center;
      padding-left: 0 !important;
      &:first-child {
        margin-top: 22px;
      }
    }
    .is-active {
      border-radius: 5px;
      background-color: rgba(25, 102, 254, 1);
    }
  }

  .carous {
    .cHead {
      margin: 72px 0 32px 70px;
      // margin-bottom: 32px;
      height: 42px;
      font-weight: 500;
      font-size: 30px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
    }
    .carousLine {
      margin: 0 0 24px 70px;
      //   margin-bottom: 24px;
      max-width: 800px;
      //   height: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      img {
        margin-right: 8px;
      }
    }
  }
  /deep/ .el-carousel {
    box-shadow: 0px 5px 10px 0px rgba(199, 209, 228, 0.3);
    width: 972px;
    // height: 402px;
    border-radius: 24px;
    background: url("../../static/images/zoumadeng.png") no-repeat center;
    background-size: cover;

    &::-webkit-scrollbar,
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      display: none;
      margin-top: -1px;
      width: 0;
      height: 0;
      background: transparent;
    }
    .el-carousel__container {
      width: 972px;
      //   height: 360px;
    }
    .el-carousel__item {
      //   border-radius: 24px;
      display: flex;
      flex-direction: column;
      width: 972px;
      min-height: 100%;
      height: auto;

      //   height: 402px;
      //   height: 100%;
      //   width: 100%;
    }
    .is-animating {
      -webkit-transition: -webkit-transform 2s ease-in-out;
      transition: -webkit-transform 2s ease-in-out;
      transition: transform 2s ease-in-out;
      transition: transform 2s ease-in-out, -webkit-transform 2s ease-in-out;
    }
    .el-carousel__button {
      background-color: #5f5f5f;
    }
    .is-active {
      .el-carousel__button {
        background-color: rgba(25, 102, 254, 1);
      }
    }
  }
}
.slide-carous-enter-active,
.slide-carous-leave-active,
.slide-carous-enter-active,
.slide-carous-leave-active {
  width: 100%;
  height: 100%;
  will-change: transform;
  transition: all 200ms cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  backface-visibility: hidden;
}
.slide-carous-enter-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-carous-leave-active {
  opacity: 0;
  transform: translate3d(3%, 0, 0);
}
.slide-carous-enter-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-carous-leave-active {
  opacity: 0;
  transform: translate3d(-3%, 0, 0);
}
.slide-carous-enter,
.slide-carous-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

// fate
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s; /* 设置过渡时间和属性 */
}

.fade-enter,
.fade-leave-to {
  opacity: 0; /* 设置起始和结束状态的透明度 */
}
/* 开始 */
//dialogFade 是容器的类名
// <transition name="dialogFade">过度内容</transition >
.dialogFade-enter,
.dialogFade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
/* 过程 */
.dialogFade-enter-active {
  transition: all 0.5s;
}
/* 结束 */
.dialogFade-enter-to {
  opacity: 1;
}
.dialogFade-leave-active {
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue